module.exports = __webpack_public_path__ + "img/0022.251ebd1b.jpg";